import React__default, { useContext } from 'react';
import { M as Modal } from '../../chunks/bundle-tZpfBaVT.js';
import '../../chunks/bundle-FpyOg33P.js';
import '../../chunks/bundle-afcKlUXe.js';
import { ButtonTypes } from '../../ui/Button.js';
import { L as LocalizationContext } from '../../chunks/bundle-qXzcabru.js';
import { u as useChannelContext } from '../../chunks/bundle-e3Ti36sK.js';
import { g as getModalDeleteMessageTitle } from '../../chunks/bundle-DzuA_apO.js';
import 'react-dom';
import '../../chunks/bundle-ZdB7DVTk.js';
import '../../chunks/bundle-PS5DHcTM.js';
import '../../ui/IconButton.js';
import '../../ui/Icon.js';
import '../../chunks/bundle-Qz8Xvs0V.js';
import '../../chunks/bundle-oJDE4gxT.js';
import '../../chunks/bundle-_iM6nCNy.js';
import '../../useSendbirdStateContext.js';
import '../../withSendbird.js';
import '../../chunks/bundle-MbdTAPd0.js';
import '../../chunks/bundle-FKPPxTH5.js';
import '../../chunks/bundle-beh08z4N.js';
import '../../chunks/bundle-HBHAJNcI.js';
import '../../utils/message/getOutgoingMessageState.js';
import '../../chunks/bundle-nfdZFsK-.js';
import '@sendbird/chat/message';
import '../../chunks/bundle-Qobh-hS4.js';
import '../../chunks/bundle-tIZkKr0f.js';
import '@sendbird/chat/groupChannel';
import '../../chunks/bundle--bKgEN9C.js';
import '../hooks/useInitialMessagesFetch.js';
import '../../chunks/bundle-PjrYdsK-.js';
import '../../chunks/bundle-wxDl4Uqr.js';
import '../../chunks/bundle-BQL-EsqQ.js';
import '../../chunks/bundle-KYdFoSY3.js';

var RemoveMessage = function (props) {
    var _a;
    var _b = props.onSubmit, onSubmit = _b === void 0 ? function () { } : _b, onCancel = props.onCancel, message = props.message;
    var stringSet = useContext(LocalizationContext).stringSet;
    var deleteMessage = useChannelContext().deleteMessage;
    return (React__default.createElement(Modal, { type: ButtonTypes.DANGER, disabled: ((_a = message === null || message === void 0 ? void 0 : message.threadInfo) === null || _a === void 0 ? void 0 : _a.replyCount) > 0, onCancel: onCancel, onSubmit: function () {
            deleteMessage(message).then(function () {
                // For other status such as PENDING, SCHEDULED, and CANCELED,
                // invalid parameters error is thrown so nothing happens.
                onSubmit();
                onCancel();
            });
        }, submitText: stringSet.MESSAGE_MENU__DELETE, titleText: getModalDeleteMessageTitle(stringSet, message) }));
};

export { RemoveMessage as default };
//# sourceMappingURL=RemoveMessageModal.js.map
